"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Bookmark = function Bookmark(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "14",
    height: "20",
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.5 2V17.7929C1.5 18.2383 2.03857 18.4614 2.35355 18.1464L6.29289 14.2071C6.68342 13.8166 7.31658 13.8166 7.70711 14.2071L11.6464 18.1464C11.9614 18.4614 12.5 18.2383 12.5 17.7929V2C12.5 1.44772 12.0523 1 11.5 1H2.5C1.94772 1 1.5 1.44772 1.5 2Z",
    fill: fill,
    stroke: fill,
    strokeWidth: "1"
  }));
};
Bookmark.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Bookmark.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Bookmark;